const OvertimeRoutes = [
    //
    {
        path: '/overtime/overtime-record',
        name: 'OvertimeRecord',
        component: () => import('@/views/Overtime/OvertimeRecordView.vue'),
    },
    {
        path: '/overtime/overtime-report',
        name: 'overtime-report',
        component: () => import('@/views/Overtime/OvertimeReportView.vue'),
    },
]

export default OvertimeRoutes;